import React from 'react';
import Card from '../components/About/Card/Card';
import '../styles/About.css';
import doctor from '../images/641c617bc9d2b30001e6dc47.avif';
import doctorin from '../images/641c6186efee980001ef5a1f.avif';


const About = () => {
  return (
    <div className="about">
      <div className="about-heading">
        <h1 className="heading-1">हितहितम् सुखं दुःखमायुस्तस्य हितहितम् |

</h1>
        <h1 className="heading-2">
          <span>मनाञ्च </span> तच्च यत्रोक्तमायुर्वेदः स उच्यते ||
        </h1>
      </div>
      <div className="about-main-heading">
        <h1>Our Doctors</h1>
      </div>
      <div className="about-container">
        <Card doctorName="Dr. Ninad Naik" cardText="Dr. Ninad Naik, MD in Ayurveda and PGDCR, serves as the HOD at Lokmanya Ayurved Hospital and Research Centre. With expertise in cardiac health, diabetes, and more, he has led Ayurvedic and allopathic clinical trials. Renowned for surgical skills, he's served 1000+ patients for cardiac prevention." image={doctor} />
        <Card doctorName="Dr. Tanuja Naik" cardText="Vd Tanuja Naik, a fourth-generation Ayurvedic practitioner with a BAMS and MA in Sanskrit, boasts 16 years of experience. Recognized for academic excellence and awarded the Chikitsak Puraskar, she has presented papers in national seminars and published research in PubMed." image={doctorin}/>
     
      </div>
    </div>
  );
};

export default About;
